import React from 'react'
import { observer } from 'mobx-react'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'

@observer
class SubscriptionTabs extends React.Component {
  handleSelect = event => {
    this.props?.handleTabChange(event)
  }
  render() {
    const { firstTab, secondTab, firstTabName, secondTabName } = this.props
    return (
      <Tabs
        activeKey={this.props?.activeTab || 'schedule'}
        onSelect={e => this.handleSelect(e)}
        id="uncontrolled-tab-example"
        unmountOnExit={true}
        className="subscription-tabs-wrapper subs-tabs-wrapper"
        fill>
        <Tab
          eventKey="schedule"
          data-testid="subscription_schedule"
          title={firstTabName}>
          {firstTab()}
        </Tab>
        <Tab
          eventKey="subscription"
          data-testid="next_Order"
          title={secondTabName}>
          {secondTab()}
        </Tab>
      </Tabs>
    )
  }
}

export { SubscriptionTabs }
export default SubscriptionTabs
